<template>
  <div :class="{'mod-filter': true, 'isJJC': isJJC}">
    <div class="cell-header" style="height: 60px; line-height: 60px">
      <!-- <div class="info-wrapper float-left" v-if="segment.businessPrice || segment.economyPrice">
        <span class="label">民航公布价</span>:
        <span v-if="segment.businessPrice">公务舱{{ segment.businessPrice }}元; </span>
        <span v-if="segment.economyPrice">经济舱{{ segment.economyPrice }}元</span>
      </div> -->
      <div class="header-tips">飞飞乐现金抽奖</div>
      <div class="filter-wrapper">
        排序方式：
        <a-select :defaultValue="defaultValue" style="width: 200px;" @change="handleChange">
          <a-select-option value="default">综合排序</a-select-option>
          <a-select-option value="priceAsc">价格从低到高</a-select-option>
          <a-select-option value="priceDesc">价格从高到低</a-select-option>
          <a-select-option value="dateAsc">出发时间由早到晚</a-select-option>
          <a-select-option value="dateDesc">出发时间由晚到早</a-select-option>
        </a-select>
      </div>
    </div>
  </div>
</template>

<script>
import '../css/filter.less'

const mainSettings = window.__MICRO_ROOT__ ?? {}
const { airline } = mainSettings

export default {
  props: {
    segment: Object,
    isJJC: Boolean,
    products: Array,
    type: {
      type: String,
      default: 'normalFlight'
    },
    defaultSelect: {
      type: String,
      default: 'dateAsc'
    }
  },
  data () {
    return {
      airline,
      defaultValue: 'dateAsc'
    }
  },
  created () {
    this.defaultValue = this.defaultSelect
    if (this.type === 'normalFlight') {
      if (['FU', 'JD'].includes(this.airline)) {
        this.defaultValue = 'default'
      }
    }
    this.handleChange(this.defaultValue)
  },
  methods: {
    handleChange (value) {
      this.$emit('sort', value)
    }
  }
}
</script>
